// Registers the LEOVERA admin service worker, scoped to /admin only so the
// public storefront is never intercepted (it deliberately runs without a SW).
export function registerAdminServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.register("/sw.js", { scope: "/admin" }).catch(() => {
    /* registration failed — admin still works online */
  });
}
